import { Field, Label, Switch as HuiSwitch } from "@headlessui/react";

import { cn } from "./cn";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function Switch({ checked, onChange, label, disabled = false }: SwitchProps) {
  const control = (
    <HuiSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={cn(
        "relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
        "bg-line transition-colors data-checked:bg-accent",
        "data-disabled:cursor-not-allowed data-disabled:opacity-50",
      )}
    >
      <span
        aria-hidden
        className={cn(
          "pointer-events-none inline-block size-4 transform rounded-full bg-white shadow-sm",
          "transition-transform duration-150",
          checked ? "translate-x-4" : "translate-x-0",
        )}
      />
    </HuiSwitch>
  );

  if (label === undefined) return control;

  return (
    <Field className="flex items-center gap-2.5">
      {control}
      <Label className="cursor-pointer text-sm text-fg select-none">{label}</Label>
    </Field>
  );
}
